var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultLayout',{attrs:{"pageProps":{
    title: _vm.isWebApp ? ("Redirecting you to " + (_vm.customer.name) + "...") : '',
  }},scopedSlots:_vm._u([{key:"content",fn:function(){return [(_vm.loading && !_vm.isWebApp)?_c('b-spinner',{attrs:{"variant":"primary"}}):_vm._e()]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }